import { IconButton } from 'Components/shared/IconButton';
import { ReplyBox } from 'Components/shared/MessageBubble/ReplyBox';
import styled from 'styled-components';

const MessageInputArea = styled.div`
  position: relative;
`;

const StyledReplyBox = styled(ReplyBox)`
  margin: 15px 15px 0;
`;

const InputAndBannerWrapper = styled.div`
  grid-row: 2;
  width: 100%;
  position: relative;
  background-color: ${({ theme }) => theme.colors.base};
`;

const InputWrapper = styled.div`
  grid-row: 2;
  width: 100%;
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.base};
`;

const SubmitIconButton = styled(IconButton)`
  margin-left: ${({ theme }) => theme.sizes.xxxsmall};
  grid-row: 2;
  grid-column: 2;
`;

const MessageBar = styled.div<{ largeMargin: boolean }>`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  margin: 10px auto 0;
  margin: ${({ largeMargin }) => (largeMargin ? '40px' : '10px')} auto 0;
  transition: 300ms margin linear;
`;

const MessageInfo = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #277ee3;
  font-size: 14px;
  cursor: default;
  min-height: 3em;
  padding: 0.85em 1em 0.6em 1em;
  width: 100%;
  text-align: center;
  color: white !important;
  z-index: 2;
  border-radius: 4px;
`;

const FileInput = styled.input`
  position: relative;
  opacity: 0;
`;

const AttachmentIconContainer = styled.label`
  position: absolute;
`;

export const Styled = {
  AttachmentIconContainer,
  FileInput,
  MessageBar,
  MessageInputArea,
  ReplyBox: StyledReplyBox,
  InputAndBannerWrapper,
  InputWrapper,
  SubmitIconButton,
  MessageInfo,
};
